/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { connect } from 'react-redux';
import { colors } from '_styles';
import { AiFillMinusSquare, AiFillPlusSquare } from 'react-icons/ai';
import { _ } from '_locales';
import { Button } from '../../Education/components';

const SelectBulkItems = ({
  mainColor, currentPage, setCurrentPage, bpItems, setBpItems,
}) => {
  const fee = Object.values(bpItems)[0]?.options[0]?.fee;
  const hasPayment = fee && fee !== '$0.00';
  const [expandedItems, setExpandedItems] = useState([]);
  const { main_color } = mainColor;

  const removeItemHandler = (key, itemName) => {
    const copy = { ...bpItems };
    const options = [...copy[key].options];
    if (options.filter((item) => item.mat_nm === itemName)[0].count === 0) return;
    const modifiedOptions = options.map((item) => ({
      ...item,
      count: itemName === item.mat_nm
        ? item.count - 1 : item.count
    }));
    copy[key] = { ...copy[key], options: modifiedOptions };
    setBpItems(copy);
  };

  const addItemHandler = (key, itemName) => {
    const copy = { ...bpItems };
    const options = [...copy[key].options];
    const modifiedOptions = options.map((item) => ({
      ...item,
      count: (itemName === item.mat_nm && item.max_qty > item.count)
        ? item.count + 1 : item.count
    }));
    copy[key] = { ...copy[key], options: modifiedOptions };
    setBpItems(copy);
  };

  const isItemSelected = () => {
    for (const el in bpItems) {
      for (const item of bpItems[el].options) {
        if (item.count > 0) {
          return true;
        }
      }
    }

    return false;
  };

  return (
    <Container>
      <TextHeader>
        Please indicate what items you have for pick-up
      </TextHeader>

      <StyledView>
        <HeaderRow>
          <StyledText flex={5}>
            {_('bulkPickup.accepted_items')}
          </StyledText>
          <HeaderRight>
            <StyledText flex={1} textAlign={hasPayment ? 'center' : 'right'} marginRight={hasPayment ? 14 : 35}>
              {_('bulkPickup.qty')}
            </StyledText>
            {hasPayment && (
              <StyledText flex={1} textAlign="right" paddingRight={15}>
                {_('bulkPickup.fee_each')}
              </StyledText>
            )}
          </HeaderRight>
        </HeaderRow>
        {Object.entries(bpItems).map(([key, value]) => (
          <ViewAccordion key={key}>
            <AccordionHeader
              onClick={() => setExpandedItems((s) => (s.includes(key)
                ? s.filter((i) => i !== key)
                : [...s, key]))}
            >
              <StyledTextHeader>{value.name}</StyledTextHeader>
              <StyledText style={{ paddingRight: 15 }}>
                {expandedItems.includes(key)
                  ? <FaChevronUp />
                  : <FaChevronDown />}
              </StyledText>
            </AccordionHeader>
            {expandedItems.includes(key) && value.options.map((item, index) => (
              <>
                <AccordionContent borderTop={index !== 0}>
                  <StyledText style={{ paddingLeft: 15 }} flex={5}>{item.mat_nm}</StyledText>
                  <ContentRight hasPayment={hasPayment}>
                    <Counter>
                      <AiFillMinusSquare cursor="pointer" fontSize={30} color={item.count === 0 ? '#D9D9D9' : '#FF1D1E'} onClick={() => removeItemHandler(key, item.mat_nm)} />
                      <StyledText bold>{item.count}</StyledText>
                      <AiFillPlusSquare cursor="pointer" fontSize={30} color="#177BC2" onClick={() => addItemHandler(key, item.mat_nm)} />
                    </Counter>
                    {hasPayment && (
                      <StyledText bold color="rgb(24, 123, 193)" marginRight="10px">
                        {item.fee}
                      </StyledText>
                    )}
                  </ContentRight>

                </AccordionContent>
                {item?.description && (
                  <ItemDescription>
                    *
                    {item.description}
                  </ItemDescription>
                )}
              </>

            ))}
          </ViewAccordion>
        ))}
      </StyledView>
      <ButtonRow>
        <Button
          backgroundColor="fff"
          color={main_color || colors.RC_ACTION}
          aria-label={'Back'}
          fontSize="16px"
          padding="12px 24px"
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          {_('bulkPickup.back')}
        </Button>
        <Button
          mainColor={main_color || false}
          aria-label={'Next'}
          onClick={() => setCurrentPage(currentPage + 1)}
          fontSize="16px"
          padding="12px 24px"
          disabled={!isItemSelected()}
        >
          {_('bulkPickup.next')}
        </Button>
      </ButtonRow>
    </Container>
  );
};

export default connect((state) => ({
  mainColor: state.config.templateColour ? JSON.parse(state.config.templateColour) : {},
}), null)(SelectBulkItems);

const OpacityAnimation = keyframes`
  from { opacity: 0;}
  to { opacity:1;}
`;

const Container = styled.div`
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  margin-bottom: 35px;
`;

const StyledView = styled.div`
  animation: ${OpacityAnimation} 0.5s;
  margin-bottom: 30px;
  padding: 20px;
`;

const ViewAccordion = styled.div`
  border: 2px solid rgb(231, 236, 239);
  margin: 4px 0;
  transition: 0.3s;
  &:hover {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  }
`;

const AccordionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 3px;
  border-bottom: 1px solid rgb(231, 236, 239);
`;

const AccordionContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: ${(props) => (props.borderTop ? '1px solid rgb(231, 236, 239)' : 'none')};
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const HeaderRight = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  gap: 5px;
  padding-right: 5px;
`;

const ContentRight = styled.div`
  display: flex;
  flex: 2;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
  padding-right: 5px;
  margin: ${(props) => (props.hasPayment ? '0' : '0 10px 0 auto')};
`;

const Counter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  justify-content: flex-end;
  padding: 20px;
`;

const TextHeader = styled.h3`
  letter-spacing: 1px;
  cursor: pointer;
  padding: 15px 10px 15px 9px !important;
  font-size: 18px !important;
  color: rgb(64, 64, 64) !important;
  font-weight: 600 !important;
  font-family: Roboto, sans-serif !important;
  border-bottom: 2px solid rgb(231, 236, 239);
`;

const StyledText = styled.p`
  color: rgb(64, 64, 64);
  opacity: 0.8;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  flex: ${(props) => props.flex || 'initial'};
  text-align: ${(props) => props.textAlign || 'initial'};
  margin-right: ${(props) => props.marginRight || 'initial'};
  padding-right: ${(props) => props.paddingRight || 'initial'};
`;

const StyledTextHeader = styled(StyledText)`
  padding: 0 15px;
  font-size: 20px;
  font-weight: 600;
  color: #000;
`;

const ItemDescription = styled.p`
  padding-left: 15px;
  margin: 0;
  font-style: italic;
  font-size: 12px;
  color: rgb(64, 64, 64);
  margin-bottom: 10px;
  font-family: Roboto, sans-serif !important;
`;
